// extracted by mini-css-extract-plugin
export var textInput = "_fd-0";